import type {
  CubeInfo,
  CubeLinesIds,
  FaultInfo,
  Survey2dInfo,
  Survey2dProfileInfoType,
} from '@core/core/types'
import { check } from 'common/helpers'

import type {
  CubeInfo as ApiCubeInfo,
  FaultInfo as ApiFaultInfo,
  ProjectCubeLineInfo as ApiProjectCubeLineInfo,
  Survey2DInfo as ApiSurvey2DInfo,
  SurveyProfile as ApiSurveyProfileInfo,
} from './__generated__/data-contracts'

export function convertToCubeInfo(from: ApiCubeInfo): CubeInfo {
  return {
    id: check(from.uid),
    //Проверка fieldUid убрана, т.к. в мастер импорте бек его поставить не сможет
    fieldId: from.fieldUid ?? null,
    domain: check(from.domainType),
    name: check(from.name),
    shapeIlines: check(from.shapeIlines),
    shapeXlines: check(from.shapeXlines),
    shapeHlines: check(from.shapeHlines),
    rangeIlinesMin: check(from.rangeIlinesMin),
    rangeXlinesMin: check(from.rangeXlinesMin),
    rangeHlinesMin: check(from.rangeHlinesMin),
    rangeIlinesMax: check(from.rangeIlinesMax),
    rangeXlinesMax: check(from.rangeXlinesMax),
    rangeHlinesMax: check(from.rangeHlinesMax),
    amplitudeMin: check(from.statistics.min),
    amplitudeMax: check(from.statistics.max),
    stepILines: check(from.stepILines),
    stepXLines: check(from.stepXLines),
    stepHLines: check(from.stepHLines),
    shift: check(from.twtShift),
  }
}

export function convertToCubeLinesIds(from: ApiProjectCubeLineInfo[]): CubeLinesIds {
  return {
    iLine: from.find(line => line.lineType === 'Iline')?.uid ?? '',
    xLine: from.find(line => line.lineType === 'Xline')?.uid ?? '',
    Hline: from.find(line => line.lineType === 'ZSlice')?.uid ?? '',
  }
}

export function convertToFaultInfo(from: ApiFaultInfo): FaultInfo {
  return {
    id: from.uid,
    name: from.name,
    domain: from.domainType,
    fieldId: from.fieldUid ?? undefined,
  }
}

export function convertToSurvey2d(from: ApiSurvey2DInfo): Survey2dInfo {
  return {
    id: from.uid,
    fieldId: from.fieldUid ?? undefined,
    name: from.name,
    domain: from.domainType,
    profiles: from.surveyProfiles.map(profile => convertToSurvey2dProfile(profile)),
  }
}

function convertToSurvey2dProfile(from: ApiSurveyProfileInfo): Survey2dProfileInfoType {
  return {
    id: from.id,
    name: from.name,
  }
}
